export default "__VITE_ASSET__b82eac26__"